<template>
  <div class="form-group form-item">
    <label>{{title}}</label>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'FormItem',
    props: ['title'],
    data() {
      return {}
    },
    created() {

    },
    methods:{

    }
  }
</script>

<style scoped lang="scss">
  label {
    display: block !important;
    clear: both !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Base/FormItem.vue